import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 48 48" fill="none" {...props}>
      <title>{props.title || 'Quality'}</title>
      <g xmlns="http://www.w3.org/2000/svg">
        <path
          d="M24 0C37.2857 0 48 10.7143 48 24C48 37.2857 37.2857 48 24 48C10.7143 48 0 37.2857 0 24C0 10.7143 10.7143 0 24 0Z"
          fill="#D7D7FF"
        />
        <path
          d="M31.468 16.5991L24.6608 23.4063C24.4859 23.5814 24.2487 23.6798 24.0012 23.6798C23.7538 23.6798 23.5165 23.5814 23.3417 23.4063L21.2012 21.2659"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.9368 26.4321L10 32.4653L14.6667 33.3986L16.5334 38.9987L21.4989 31.1188"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M33.064 26.4321L38.0008 32.4653L33.3341 33.3986L31.4674 38.9987L26.502 31.1188"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M33.3334 21.9339L34.3837 24.6916C34.5407 25.1015 34.3904 25.5654 34.0229 25.8054L31.5513 27.4232L30.7798 30.273C30.6651 30.6965 30.2709 30.9829 29.8327 30.9612L26.8846 30.8144L24.5861 32.6661C24.2437 32.9412 23.7561 32.9412 23.4138 32.6661L21.1153 30.8106L18.1671 30.9575C17.7289 30.9792 17.3348 30.6928 17.2201 30.2693L16.4485 27.4195L13.977 25.8017C13.6094 25.5617 13.4591 25.0978 13.6161 24.6879L14.6664 21.9339L13.6161 19.1749C13.4563 18.7632 13.6069 18.2958 13.977 18.0549L16.4485 16.4371L17.2201 13.5872C17.3348 13.1638 17.7289 12.8773 18.1671 12.899L21.1153 13.0521L23.4138 11.2053C23.7561 10.9303 24.2437 10.9303 24.5861 11.2053L26.8846 13.0521"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </Icon>
  )
}
